import React from 'react';
import { useSimulatorPageLogic } from './useSimulatorPageLogic';
import AppLayout from '../../components/layout/AppLayout/AppLayout';
import ClientIdentificationCard from '../../components/features/client/ClientIdentificationCard';
import PropertyCard from '../../components/features/property/PropertyCard';
import CreditAnalysisCard from '../../components/features/credit/CreditAnalysisCard';
import WalletCard from '../../components/features/wallet/WalletCard';
import Simulation from '../../components/features/simulation/Simulation.jsx';
import PrintButton from '../../components/print/PrintButton/PrintButton';
import Print from '../../components/print/Print';
import { AlertProvider } from '../../components/layout/Alert/AlertContext';
import AlertContainer from '../../components/layout/Alert/AlertContainer';
import FormRow from '../../components/form/FormRow/FormRow';
import FormColumn from '../../components/form/FormColumn/FormColumn';
import { useLayoutContext } from '../../contexts/LayoutContext';
import styles from './SimulatorPage.module.css';
import Button from "../../components/form/Button/Button";

function SimulatorPage() {
    const { isMRV } = useLayoutContext();
    const {
        resetKey,
        clientData,
        propertyData,
        creditAnalysisData,
        walletData,
        simulationResult,
        isPrintEnabled,
        showResult,
        totalIncome,
        showWalletCard,
        isPropostaIdeal,
        parcelamentoMaximoPropostaIdeal,
        setShowWalletCard,
        setClientData,
        setPropertyData,
        setCreditAnalysisData,
        setWalletData,
        handleTotalIncomeChange,
        handlePrintClick,
        handleSimulationComplete,
        handleClearForm,
        setIsPrintEnabled,
        setShowResult
    } = useSimulatorPageLogic();

    return (
        <AlertProvider>
            <AlertContainer />
            <AppLayout>
                <ClientIdentificationCard
                    key={`client-${resetKey}`}
                    setClientData={setClientData}
                    onTotalIncomeChange={handleTotalIncomeChange}
                />

                <FormRow>
                    <FormColumn cols={6}>
                        <div className={styles.equalHeightCard}>
                            <PropertyCard
                                key={`property-${resetKey}`}
                                setPropertyData={setPropertyData}
                                isMRV={isMRV}
                            />
                        </div>
                    </FormColumn>
                    <FormColumn cols={6}>
                        <div className={styles.equalHeightCard}>
                            <CreditAnalysisCard
                                key={`credit-${resetKey}`}
                                setCreditAnalysisData={setCreditAnalysisData}
                                totalIncome={totalIncome}
                            />
                        </div>
                    </FormColumn>
                </FormRow>

                <div style={{ display: showWalletCard ? 'block' : 'none' }}>
                    <WalletCard
                        key={`wallet-${resetKey}`}
                        setWalletData={setWalletData}
                        simulationResult={simulationResult}
                        isMRV={isMRV}
                        pagadoria={clientData?.pagadoria}
                        parcelamentoMaximoPropostaIdeal={parcelamentoMaximoPropostaIdeal}
                    />
                </div>

                <Simulation
                    key={`simulation-${resetKey}`}
                    propertyData={propertyData}
                    clientData={clientData}
                    creditAnalysisData={creditAnalysisData}
                    walletData={walletData}
                    showResult={showResult}
                    setShowWalletCard={setShowWalletCard}
                    showWalletCard={showWalletCard}
                    onSimulationComplete={handleSimulationComplete}
                    simulationResult={simulationResult}
                    isMRV={isMRV}
                    isPropostaIdeal={isPropostaIdeal}
                    setIsPrintEnabled={setIsPrintEnabled}
                    setShowResult={setShowResult}
                />

                <div className={styles.ButtonContainer}>
                    <Button onClick={handleClearForm} variant="danger" className={styles.clearButton}>
                        Limpar Formulário
                    </Button>

                    <PrintButton
                        onClick={handlePrintClick}
                        disabled={!isPrintEnabled}
                    />
                </div>

                <Print
                    simulationResult={simulationResult}
                    clientData={clientData}
                    propertyData={propertyData}
                    isMRV={isMRV}
                />
            </AppLayout>
        </AlertProvider>
    );
}

export default SimulatorPage;